//@flow
import React from 'react';
import SVGInline from 'react-svg-inline';
import injectSheet from 'react-jss';
import { useSelector } from 'react-redux';
import { sendTrackingEvent, activeTrialPlanNameSelector, currentPlanDetailsSelector } from 'h-commons';

import { getPlanNameBeforeUnderscore } from '../../settings/components/Account/ExplorePlans/utils';
import { EXPLORE_YOUR_PLAN_TRACKING_EVENTS } from '../../settings/components/Account/ExplorePlans/constants/constants';


const UpgradeSuccessModal = (props: Props) => {
    const { onSubmit, classes, planName, planType } = props;
    const activeTrialPlanName = useSelector(activeTrialPlanNameSelector);
    const currentPlanDetails = useSelector(currentPlanDetailsSelector);
    const done = () => {
        onSubmit(true);
    }
    if (activeTrialPlanName) { // Trigger event only if there is an active trial ongoing
        sendTrackingEvent(EXPLORE_YOUR_PLAN_TRACKING_EVENTS.UPGRADE_DURING_PLAN_TRIAL, 
            { currentPlanName: currentPlanDetails.name, trialPlanName: getPlanNameBeforeUnderscore(activeTrialPlanName) });
    }
    return (
        <React.Fragment>
            <div className={`${classes.root} h-flexbox--vertical h-flexbox--se`}>
                <div>
                    <SVGInline height="61px" width="54px" svg={require('../images/star.svg')} />
                </div>
                <div className="h-s2">
                    You have been upgraded to our {planName} {planType} plan. For any queries please contact support@hiverhq.com
                </div>
                <div className="h-flexbox--center">
                    <div className={`${classes.link} h-s1 h-pointer`} onClick={done}>Great</div>
                </div>
            </div>
        </React.Fragment>
    );
}
type Props = {
    onSubmit: Function,
    classes: Object,
    planName: string,
    planType: string
}
export default injectSheet({
    root: { height: 260, padding: '0 10px' },
    img: { 
        width: '54px',
        height: '61px',
    },
    title: { fontSize: 25, fontWeight: '400'},
    link: {
        color: '#35b5e5',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
})(UpgradeSuccessModal);
